import { tools } from '@/utils/tools';
import dayjs from 'dayjs';

const handleShowValue = (fieldInfo, handleValue) => {
  if (!fieldInfo) return null;
  const dataFieldExt = fieldInfo?.fieldExt;
  if (fieldInfo.fieldType === 7) {
    //数字
    const { numberUnit } = tools.isJSON(dataFieldExt) ? JSON.parse(dataFieldExt) : {};
    return tools.getNumberShow(handleValue, dataFieldExt) + `${numberUnit ?? ''}`;
  }
  if (fieldInfo.fieldType === 16) {
    //金额
    const res = tools.getPriceShow(handleValue, dataFieldExt);
    return res;
  }
  if (fieldInfo.fieldType === 23) {
    //百分比
    return tools.getPercentage(handleValue, dataFieldExt) + '%';
  }
  if (fieldInfo.fieldType === 24) {
    // 计算字段
    const checkExt = tools.isJSON(dataFieldExt) ? JSON.parse(dataFieldExt) : {};
    const { type } = checkExt;

    if (type === 7 || type === 5) {
      //数字,汇总数字
      return tools.getNumberShow(handleValue, dataFieldExt);
    }

    if (type === 16 || type === 6) {
      //金额，汇总金额
      return tools.getPriceShow(handleValue, dataFieldExt);
    }
    if (type === 23) {
      return tools.getPercentage(handleValue, dataFieldExt) + '%';
    }
    return handleValue;
  }

  if (fieldInfo.fieldType === 2 || fieldInfo.fieldType === 4) {
    // 单选按钮
    return handleValue;
  }

  if (fieldInfo.fieldType === 3 || fieldInfo.fieldType === 5) {
    return handleValue?.split(',')?.filter((c) => Boolean(c));
  }

  if (fieldInfo.fieldType === 8) {
    // 日期
    return dataFieldExt ? dayjs(handleValue).format(dataFieldExt) : handleValue;
  }

  if (fieldInfo.fieldType === 9 && handleValue) {
    // 日期范围
    const changeValue = JSON.parse(handleValue);
    const hasVal = Object.keys(changeValue)?.length;
    const { beginDate, endDate } = changeValue;
    return hasVal > 0 ? `${beginDate}/${endDate}` : null;
  }

  if (fieldInfo.fieldType === 6) {
    // const {single } = JSON.parse(dataFieldExt); // 是否单选
    return handleValue?.map((hItem) => hItem.userName);
  }

  if (fieldInfo.fieldType === 10) {
    // 级联

    // const resultLabel = flattExt.filter((fItem) => innerVal?.includes(fItem.value))?.map((mItem) => mItem.label);
    return handleValue;
  }

  if (fieldInfo.fieldType === 22) {
    return handleValue?.map((hItem) => hItem.name);
  }

  if (fieldInfo.fieldType === 18) {
    const fileVal = JSON.parse(handleValue);

    return fileVal?.map((fItem) => ({
      url: fItem.url,
      name: fItem.name
    }));
  }

  if (fieldInfo.fieldType === 12 || fieldInfo.fieldType === 25) {
    return handleValue?.map((hItem) => hItem.label);
  }

  if (fieldInfo.fieldType === 26) {
    const labelDoc = tools.handleRichText(handleValue);

    return { labelDoc, handleValue };
  }

  if (fieldInfo.type == 1 && fieldInfo.fieldType === 0 && fieldInfo.fieldKey == 'qccId') {
    return handleValue ? '是' : '否';
  }

  return handleValue;
};

const textNumberList = [0, 1, 7, 23, 16, 13, 24, 10, 11, 8];
const selectList = [2, 3, 4, 5];
const dateTxtList = [9];
const personList = [6, 22];
const fileList = [18];
const findList = [12, 25];
const richTxtList = [26];

export { handleShowValue, textNumberList, selectList, dateTxtList, personList, fileList, findList, richTxtList };
